import styled from "styled-components";

export const Container = styled.button`
  background: #f6f6f6;
  border-radius: 8px;
  border: 1px solid #d8d8d8;
  padding: 5px 12px 6px;
  width: 100%;
  text-align: left;
  cursor: pointer;
`;

export const Label = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: #757575;
  text-transform: uppercase;
  margin-bottom: 4px;
`;

export const DisplayText = styled.div`
  font-size: 16px;
  font-weight: 900;
  color: #000000;
`;

export const SubtitleSpan = styled.span`
  font-weight: 400;
  color: #757575;
`;

export const ErrorText = styled.div`
  margin-top: 4px;
  margin-left: 12px;
  font-size: 12px;
  color: #ef4444;
`;

